// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"159":"337d3186","801":"501b2433","999":"671b1158"}[chunkId] + ".chunk.css";
};